import { UpdateFiltersWithNestedItemsAction } from '../slice/alerts.types';

export function updateFiltersWithNestedItems(
  filtersWithNestedItems: Record<string, Record<string, boolean>>,
  payload: UpdateFiltersWithNestedItemsAction,
) {
  const { categoryKey, optionsToSelect, optionsToRemove = [], shouldClearAll } = payload;

  const currentFilterState = shouldClearAll ? {} : filtersWithNestedItems[categoryKey] || {};

  if (optionsToRemove.length) {
    optionsToRemove.forEach((optionKey) => {
      delete currentFilterState[optionKey];
    });
  }

  if (optionsToSelect.length) {
    optionsToSelect.forEach((optionKey) => {
      currentFilterState[optionKey] = true;
    });
  }

  if (Object.keys(currentFilterState).length) {
    filtersWithNestedItems[categoryKey] = currentFilterState;
  } else {
    delete filtersWithNestedItems[categoryKey];
  }
}
